import VueLib from 'vue'
import merge from 'lodash.mergewith'
import * as Sentry from '@sentry/browser'
import { Dedupe, ExtraErrorData, ReportingObserver, RewriteFrames, Vue } from '@sentry/integrations'

import { Integrations as TracingIntegrations } from '@sentry/tracing'

export default function (ctx, inject) {
  /* eslint-disable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  const config = {
    dsn:"https:\u002F\u002F09cb286be7c849848f1c3387e08fc12a@o267508.ingest.us.sentry.io\u002F1823254",
    environment:"kuma-prod-mc",
    enabled:true,
    sampleRate:0.00001,
    beforeSend:function(event, hint) {
        // message
        if (event.message) {
          if (event.message.match(/ReportingObserver/i)) {
            return null
          }
        }

        // error
        const error = hint.originalException
        if (error && error.message) {
          if (
            error.message.match(/The connection has not been established yet/i)
          ) {
            return null
          }
          if (error.message.match(/The operation is insecure/i)) {
            return null
          }
          if (error.message.match(/Request aborted/i)) {
            return null
          }
          if (error.message.match(/Connection refused/i)) {
            return null
          }
          if (error.message.match(/NavigationDuplicated/i)) {
            return null
          }
          if (error.message.match(/Network Error/i)) {
            return null
          }
          if (error.message.match(/网站维护中/i)) {
            return null
          }
          if (
            error.message.match(
              /Request failed with status code (401|503|504)/i
            )
          ) {
            return null
          }
          if (
            error.message.match(/Cannot read property 'substr' of undefined/i)
          ) {
            return null
          }
          if (
            error.message.match(
              /Cannot set headers after they are sent to the client/i
            )
          ) {
            return null
          }
          if (
            error.message.match(
              /undefined is not an object \(evaluating 'document\.getElementsByTagName\('video'\)\[0]\.src'\)/i
            )
          ) {
            return null
          }
        }
        return event
      },
    tracesSampleRate:0.005
  }

  const runtimeConfigKey = "sentry"
  if (ctx.$config && runtimeConfigKey && ctx.$config[runtimeConfigKey]) {
    merge(config, ctx.$config[runtimeConfigKey].config, ctx.$config[runtimeConfigKey].clientConfig)
  }

  config.integrations = [
    new Dedupe(),
    new ExtraErrorData(),
    new ReportingObserver(),
    new RewriteFrames(),
    new Vue({ Vue: VueLib, ...{"attachProps":true,"logErrors":false,"tracing":true,"tracingOptions":{"hooks":["mount","update"],"timeout":2000,"trackComponents":true},"trackComponents":true}})
  ]

    config.integrations.push(new TracingIntegrations.BrowserTracing({}))

  /* eslint-enable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  Sentry.init(config)

  inject('sentry', Sentry)
  ctx.$sentry = Sentry
}
